// frontend/src/services/api.js
// All REST API calls — single source of truth for backend communication

const API_BASE = '';

async function request(method, path, body = null) {
  const opts = {
    method,
    headers: { 'Content-Type': 'application/json' },
  };
  if (body) opts.body = JSON.stringify(body);
  
  const res = await fetch(`${API_BASE}${path}`, opts);
  const data = await res.json();
  
  if (!res.ok) {
    console.error(`[API] Error ${method} ${path}:`, data.error || res.statusText);
    throw new Error(data.error || `HTTP ${res.status}`);
  }
  
  return data;
}

// === CARTS ===
export async function createCart(items) {
  return request('POST', '/api/carts', { items });
}

export async function getCart(cartId) {
  return request('GET', `/api/carts/${cartId}`);
}

export async function listCarts() {
  return request('GET', '/api/carts');
}

export async function addItemToCart(cartId, productCode, name, price) {
  return request('POST', `/api/carts/${cartId}/items`, { productCode, name, price });
}

export async function removeItemFromCart(cartId, productCode) {
  return request('DELETE', `/api/carts/${cartId}/items/${productCode}`);
}

export async function updateCartItems(cartId, updates) {
  return request('PATCH', `/api/carts/${cartId}/items`, { updates });
}

export async function checkoutCart(cartId, clientName, clientPhone) {
  return request('POST', `/api/carts/${cartId}/checkout`, { clientName, clientPhone });
}

export async function getBlockedProducts() {
  return request('GET', '/api/carts/blocked');
}

// === PRODUCTS ===
export async function listProducts() {
  return request('GET', '/api/products');
}

export async function getProduct(code) {
  return request('GET', `/api/products/${code}`);
}

// === AUTH ===
export async function operatorLogin(password) {
  return request('POST', '/api/auth/operator', { password });
}

export async function validateToken(token) {
  return request('POST', '/api/auth/validate', { token });
}

// === OPERATOR ===
export async function searchOperator(q) {
  return request('GET', `/api/operator/search?q=${encodeURIComponent(q)}`);
}

export async function getDashboard(params = {}) {
  const query = params.scope ? `?scope=${params.scope}` : '';
  return request('GET', `/api/operator/dashboard${query}`);
}

// === CLIENTS ===
export async function getClient(phone) {
  return request('GET', `/api/clients/${phone}`);
}

export async function updateClient(phone, data) {
  return request('PATCH', `/api/clients/${phone}`, data);
}

export async function blockProduct(code) {
  return request('POST', `/api/operator/products/${code}/block`);
}

export async function unblockProduct(code) {
  return request('POST', `/api/operator/products/${code}/unblock`);
}

export async function hideProduct(code) {
  return request('POST', `/api/operator/products/${code}/hide`);
}

export async function updateProductStatus(code, status) {
  return request('PATCH', `/api/operator/products/${code}/status`, { status });
}

// ─── Helper: formdata upload (multipart) ───
async function uploadFormData(url, formData) {
  const res = await fetch(`${API_BASE}${url}`, {
    method: 'POST',
    body: formData
  });

  // Defensive: check content-type before parsing JSON
  // (nginx can return 413 HTML if body is too large)
  const contentType = res.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    const text = await res.text();
    if (res.status === 413) {
      throw new Error('El archivo es demasiado grande. El límite es 50MB por archivo.');
    }
    if (res.status === 502) {
      throw new Error('Error de conexión con el servidor. Intenta de nuevo.');
    }
    throw new Error(`Error del servidor (${res.status}). Intenta de nuevo.`);
  }

  const data = await res.json();
  if (!res.ok) {
    console.error(`[API] Error POST ${url}:`, data.error || res.statusText);
    throw new Error(data.error || `Error del servidor (${res.status})`);
  }
  return data;
}

// === UPLOAD (FASE 1A.1 + 1A.2) ===
export async function validateUpload(formData) {
  return uploadFormData('/api/upload/validate', formData);
}

export async function createProduct(formData) {
  return uploadFormData('/api/upload/product', formData);
}

export async function addProductMedia(code, formData) {
  return uploadFormData(`/api/upload/media/${code}`, formData);
}
